// src/Components/PayPalButton.js
import React, { useEffect, useRef, useState } from "react";
import { useNavigate } from "react-router-dom";
import { useCart } from "../cart/CartContext";
import { toast } from "react-toastify";

export default function PayPalButton({ total, currency = "USD" }) {
  const paypalRef = useRef(null);
  const navigate = useNavigate();
  const { clearCart } = useCart(); // נשאר, אבל לא משתמשים כאן
  const [initialized, setInitialized] = useState(false);
  const [debouncedTotal, setDebouncedTotal] = useState(total);

  // Debounce סה״כ
  useEffect(() => {
    const t = setTimeout(() => setDebouncedTotal(total), 400);
    return () => clearTimeout(t);
  }, [total]);

  useEffect(() => {
    if (!window.paypal || !paypalRef.current || initialized) return;

    try {
      window.paypal
        .Buttons({
          style: {
            color: "gold",
            shape: "pill",
            label: "pay",
            layout: "vertical",
          },

          createOrder: (data, actions) => {
            return actions.order.create({
              purchase_units: [
                {
                  amount: {
                    currency_code: currency,
                    value: debouncedTotal.toFixed(2),
                  },
                },
              ],
            });
          },

          onApprove: (data, actions) => {
            return actions.order.capture().then(() => {
              // ❗ חשוב: לא מוחקים כאן את העגלה
              // PaymentSuccess דואג לזה רק אחרי שההזמנה נשמרת בפיירסטור

              toast.success("Payment completed successfully 🎉", {
                autoClose: 3000,
              });

              navigate("/payment-success");
            });
          },

          onError: (err) => {
            console.error("PayPal Checkout Error:", err);
            toast.error("Something went wrong. Please try again.", {
              autoClose: 4000,
            });
          },
        })
        .render(paypalRef.current);

      setInitialized(true);
    } catch (err) {
      console.error("PayPal init error:", err);
    }
  }, [currency, initialized, clearCart, navigate, debouncedTotal]);

  return <div ref={paypalRef}></div>;
}
